import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Link } from 'react-router-dom'
const ThankYou = () => {
    const [countdown, setCountdown] = useState(3);
    const navigate = useNavigate();

    useEffect(() => {
        // Start the countdown
        const interval = setInterval(() => {
            setCountdown((prev) => prev - 1);
        }, 1000);

        // Redirect after 3 seconds
        if (countdown === 0) {
            navigate('/application/view');
        }

        // Clear the interval when the component unmounts
        return () => clearInterval(interval);
    }, [countdown, navigate]);

    return (
        <div className="thank-you-page d-flex flex-column align-items-center justify-content-center vh-100 text-center bg-light">
            {/* SVG Icon */}
            <svg
                xmlns="http://www.w3.org/2000/svg"
                x="0"
                y="0"
                width="100"
                height="100"
                viewBox="0 0 50 50"
            >
                <path d="M 25 2 C 12.309534 2 2 12.309534 2 25 C 2 37.690466 12.309534 48 25 48 C 37.690466 48 48 37.690466 48 25 C 48 12.309534 37.690466 2 25 2 z M 25 4 C 36.609534 4 46 13.390466 46 25 C 46 36.609534 36.609534 46 25 46 C 13.390466 46 4 36.609534 4 25 C 4 13.390466 13.390466 4 25 4 z M 34.988281 14.988281 A 1.0001 1.0001 0 0 0 34.171875 15.439453 L 23.970703 30.476562 L 16.679688 23.710938 A 1.0001 1.0001 0 1 0 15.320312 25.177734 L 24.316406 33.525391 L 35.828125 16.560547 A 1.0001 1.0001 0 0 0 34.988281 14.988281 z" />
            </svg>
            {/* Thank You Message */}
            <h1 className="display-4">Thank You!</h1>
            <p className="lead">Your submission has been received. We appreciate your feedback.</p>
            {/* Countdown Message */}
            <p className="lead">You will be redirected to the home page in {countdown}...</p>
            {/* Optional Button */}
            <Link to="/application/view" className="btn btn-primary">Back to Home</Link>
        </div>
    );
};

export default ThankYou;
